import FormattedSize from 'I18n/components/FormattedSize';
import { fileIsImage } from 'conversations-internal-schema/file-upload/operators/fileIsImage';
import { getUploadProgress, getFile } from 'conversations-internal-schema/file-upload/operators/fileUploadGetters';
import { getFileName } from 'conversations-internal-schema/file-upload/operators/getFileName';
import { getFileSize } from 'conversations-internal-schema/file-upload/operators/getFileSize';
import { isUploadCompleted as getIsUploadComplete } from 'conversations-internal-schema/file-upload/operators/isUploadCompleted';
import ImageAttachmentPreview from './ImageAttachmentPreview';
import VizExNanoProgress from 'visitor-ui-component-library/progress/VizExNanoProgress';
import VizExCloseButton from 'visitor-ui-component-library/button/VizExCloseButton';
import styled from 'styled-components';
import { EERIE, KOALA, OLAF, PANTERA, FLINT } from 'visitor-ui-component-library/constants/WidgetColors';
import FileIcon from './FileIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "FileUploadV2__Wrapper",
  componentId: "sc-1bhcukt-0"
})(["height:96px;aspect-ratio:", ";position:relative;overflow:hidden;border-radius:20px;background-color:", ";"], ({
  $isImage
}) => $isImage ? '1 / 1' : 2.5, PANTERA);
const ImagePreview = styled(ImageAttachmentPreview).withConfig({
  displayName: "FileUploadV2__ImagePreview",
  componentId: "sc-1bhcukt-1"
})(["position:absolute;inset:0;object-fit:cover;"]);
const LoadingOverlay = styled.div.withConfig({
  displayName: "FileUploadV2__LoadingOverlay",
  componentId: "sc-1bhcukt-2"
})(["position:absolute;inset:0;background-color:rgba(0,0,0,", ");backdrop-filter:blur(", "px);border-radius:20px;transition:0.2s ease-in-out;transition-property:background-color,backdrop-filter;"], ({
  $isActive
}) => $isActive ? 0.25 : 0, ({
  $isActive
}) => $isActive ? 2 : 0);
const CloseButton = styled(VizExCloseButton).withConfig({
  displayName: "FileUploadV2__CloseButton",
  componentId: "sc-1bhcukt-3"
})(["background:", ";color:white;border-radius:50%;z-index:1;"], EERIE);
const Progress = styled(VizExNanoProgress).withConfig({
  displayName: "FileUploadV2__Progress",
  componentId: "sc-1bhcukt-4"
})(["height:8px;"]);
const ProgressWrapper = styled.div.withConfig({
  displayName: "FileUploadV2__ProgressWrapper",
  componentId: "sc-1bhcukt-5"
})(["bottom:20px;position:absolute;width:100%;opacity:", ";height:8px;background-color:", ";transition:0.2s ease-in-out;transition-property:opacity;"], ({
  $isActive
}) => $isActive ? 1 : 0, KOALA);
const FileName = styled.div.withConfig({
  displayName: "FileUploadV2__FileName",
  componentId: "sc-1bhcukt-6"
})(["color:", ";font-size:12px;line-height:24px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;position:absolute;bottom:32px;left:0;padding:8px;width:100%;"], OLAF);
const FileInfo = styled.div.withConfig({
  displayName: "FileUploadV2__FileInfo",
  componentId: "sc-1bhcukt-7"
})(["display:flex;justify-content:space-between;align-items:flex-end;padding:8px 8px 10px;position:absolute;bottom:0;width:100%;color:", ";font-size:12px;line-height:12px;"], FLINT);
const FileType = styled.div.withConfig({
  displayName: "FileUploadV2__FileType",
  componentId: "sc-1bhcukt-8"
})(["display:flex;align-items:flex-end;gap:8px;svg{fill:", ";font-size:16px;}"], OLAF);
function FileUploadV2({
  attachment,
  onRemove
}) {
  const file = getFile(attachment);
  const isUploadComplete = getIsUploadComplete(attachment);
  const isImage = file ? fileIsImage(file) : false;
  const fileName = getFileName(attachment);
  const fileExt = file === null || file === void 0 ? void 0 : file.name.split('.').pop();
  return /*#__PURE__*/_jsxs(Wrapper, {
    $isImage: isImage,
    children: [isImage && /*#__PURE__*/_jsx(ImagePreview, {
      imageFile: file
    }), /*#__PURE__*/_jsx(LoadingOverlay, {
      $isActive: !isUploadComplete
    }), !isImage && /*#__PURE__*/_jsx(FileName, {
      children: fileName
    }), /*#__PURE__*/_jsx(ProgressWrapper, {
      $isActive: !isUploadComplete,
      children: /*#__PURE__*/_jsx(Progress, {
        value: getUploadProgress(attachment)
      })
    }), !isImage && file && isUploadComplete && /*#__PURE__*/_jsxs(FileInfo, {
      children: [/*#__PURE__*/_jsxs(FileType, {
        children: [/*#__PURE__*/_jsx(FileIcon, {
          type: file.type
        }), fileExt]
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedSize, {
          value: getFileSize(attachment)
        })
      })]
    }), /*#__PURE__*/_jsx(CloseButton, {
      size: "xs",
      onClick: onRemove
    })]
  });
}
FileUploadV2.displayName = 'FileUpload';
export default FileUploadV2;